import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/outline/{S,M,L}/diagram.svg` */
export const DiagramIcon = createTripletGlyphIcon('DiagramIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 1.4502C2.30356 1.45019 2.54957 1.69638 2.5498 2L2.55859 13.3936H13.959C14.2625 13.3938 14.5088 13.6397 14.5088 13.9434C14.5085 14.2468 14.2624 14.4929 13.959 14.4932H1.57129V14.418H1.45996L1.4502 2C1.45019 1.69644 1.69638 1.45043 2 1.4502Z"
        fill="currentColor"
      />
      <path
        d="M12.8574 3.09375C13.0096 2.83089 13.3465 2.74137 13.6094 2.89355C13.8717 3.04589 13.9616 3.38187 13.8096 3.64453L10.6553 9.09277C10.4653 9.42091 10.0397 9.52463 9.71973 9.32129L7.04297 7.61719L5.00879 10.416C4.83017 10.6611 4.48669 10.7152 4.24121 10.5371C3.99555 10.3584 3.94146 10.0142 4.12012 9.76855L6.39355 6.64258L6.47949 6.54492C6.66648 6.37154 6.93833 6.32002 7.17578 6.41309L7.29102 6.47168L9.92871 8.15039L12.8574 3.09375Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.25 1.7002C2.55356 1.70019 2.79957 1.94638 2.7998 2.25L2.80957 15.1357H15.7031C16.0067 15.1358 16.2538 15.3819 16.2539 15.6855C16.2539 15.9893 16.0068 16.2353 15.7031 16.2354H1.76758V16.2197H1.71094L1.7002 2.25C1.70019 1.94644 1.94638 1.70043 2.25 1.7002Z"
        fill="currentColor"
      />
      <path
        d="M14.5244 3.51465C14.6766 3.25185 15.0125 3.16233 15.2754 3.31445C15.5381 3.4666 15.6284 3.80265 15.4766 4.06543L11.9277 10.1953C11.7335 10.5306 11.2986 10.6367 10.9717 10.4287L7.90527 8.47754L5.5791 11.6768C5.40045 11.9223 5.05715 11.9764 4.81152 11.7979C4.56591 11.6192 4.51178 11.2759 4.69043 11.0303L7.24805 7.5127L7.33594 7.41406C7.52688 7.23672 7.80418 7.18346 8.04688 7.27832L8.16504 7.33887L11.1934 9.26562L14.5244 3.51465Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.99902 2.25C3.4131 2.24968 3.74947 2.58499 3.75 2.99902L3.76367 20.1641H20.9375C21.3516 20.1641 21.6874 20.5 21.6875 20.9141C21.6875 21.3283 21.3517 21.6641 20.9375 21.6641H2.35645V21.627L2.26465 21.6279L2.25 3.00098C2.24968 2.5869 2.58499 2.25053 2.99902 2.25Z"
        fill="currentColor"
      />
      <path
        d="M19.3516 4.67773C19.5591 4.31955 20.0176 4.19712 20.376 4.4043C20.7341 4.61197 20.8569 5.07138 20.6494 5.42969L15.918 13.6016C15.6544 14.0569 15.0641 14.2011 14.6201 13.9189L10.5459 11.3262L7.45312 15.5791C7.20961 15.9139 6.74023 15.9883 6.40527 15.7451C6.07034 15.5015 5.99662 15.0322 6.24023 14.6973L9.65039 10.0078L9.70801 9.93652C9.98643 9.62312 10.4435 9.5359 10.8174 9.72559L10.8965 9.77051L14.9199 12.3311L19.3516 4.67773Z"
        fill="currentColor"
      />
    </svg>
  ),
});
